import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoadingCustomBackdrop(props) {
  const { open, openLoadingSimpleBackdrop, children = null } = props;
  const isOpen = typeof open === 'boolean' ? open : !!openLoadingSimpleBackdrop;

  return (
    <div>
      <Backdrop
        sx={{
          color: '#fff',
          // Use a z-index above the dialog/modal so it stays visible when nested inside dialogs
          zIndex: (theme) => theme.zIndex.modal + 2,
          flexDirection: 'column',
          gap: 2,
        }}
        open={isOpen}
      >
        <CircularProgress color="inherit" />
        {children && (
          <Box
            textAlign="center"
            // sx={{
            //   // bgcolor: 'rgba(255,255,255,0.95)',
            //   color: '#333',
            //   px: 3,
            //   py: 2,
            //   borderRadius: 2,
            //   boxShadow: 3,
            //   minWidth: '60%',
            //   maxWidth: '90%',
            // }}
          >
            {children}
          </Box>
        )}
      </Backdrop>
    </div>
  );
}
